export default __webpack_public_path__ + "static/media/step_D_EN.94ea1865.png";